import { render, staticRenderFns } from "./AnswerStar.vue?vue&type=template&id=f378d878&"
import script from "./AnswerStar.vue?vue&type=script&lang=js&"
export * from "./AnswerStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports